export default {
  methods: {
    currencyFormat(value, thousandsSeparatorSymbol = ',') {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol)
    },
  },
}
